import React from 'react';
import "../Figure.css"


function Figure23() {
  return (
    <div>
        <table class="equal-width-table">
          <thead>
            <tr>
            <th> </th>
              <th> Zn concentration after incubation (15min)</th>
              <th> Zn concentration after removal of the blank </th>
              <th> Zn uptake </th>
            </tr>
          </thead>
          <tbody>
          <tr>
              <th> Blank EC20 </th>
              <td> 0.15 mg/L </td>
              <td> 0 mg/L </td>
              <td> - mg/L </td>
            </tr> 
            <tr>
              <th> Blank SpaC </th>
              <td> 0.1 mg/L </td>
              <td> 0 mg/L </td>
              <td> - mg/L </td>
            </tr> 
            <tr>
              <th> Water </th>
              <td> 1.41 mg/L </td>
              <td> - mg/L </td>
              <td> - mg/L </td>
            </tr> 
            <tr>
            <th> EC20 </th>
              <td> 0.23 mg/L </td>
              <td> 0.08 mg/L </td>
              <td> 1.33 mg/L </td>
            </tr>
            <tr> 
            <th> SpaC </th>
              <td> 0.65 mg/L </td>
              <td> 0.55 mg/L </td>
              <td> 0.86 mg/L </td>
            </tr> 
            <tr>
              <th colSpan="3"className="colored-cell"> Uptake difference </th>
              <th className="colored-cell"> 0.47 mg/L </th>
            </tr> 
          </tbody>
        </table>
    </div>
  );
}

export default Figure23;